import React from 'react';

const StateFilterButtons = ({ stateFilter, setStateFilter, handleBulkAction, selectedAlerts, loading }) => {
  const renderFilterMenu = () => {
    return (<div className="bulk-actions mb-3">
      <button
        className="btn btn-warning me-2"
        title="New identical alerts will not be shown, but the alert is not considered closed until the state is updated;"
        onClick={() => handleBulkAction('INV')}
        disabled={selectedAlerts.length === 0 || loading}
      >
        Mark as Investigate
      </button>
      <button
        className="btn btn-success me-2"
        onClick={() => handleBulkAction('CLSD')}
        disabled={selectedAlerts.length === 0 || loading}
      >
        Close as Positive
      </button>
      <button
        className="btn btn-danger me-2"
        onClick={() => handleBulkAction('FA')}
        disabled={selectedAlerts.length === 0 || loading}
      >
        Close as False Alarm
      </button>
    </div>);
  }
  return (
    <div className="btn-group mb-3" role="group">
      {['New', 'Investigate', 'Not Closed', 'Closed', 'False Alarm', 'All'].map((state) => (
        <button
          key={state}
          type="button"
          className={`btn ${stateFilter === state ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => setStateFilter(state)}
        >
          {state}
        </button>
      ))}
      &nbsp;&nbsp;&nbsp;&nbsp;
      <button
        className="btn btn-warning me-2"
        title="New identical alerts will not be shown, but the alert is not considered closed until the state is updated."
        onClick={() => handleBulkAction('INV')}
        disabled={selectedAlerts.length === 0 || loading}
      >
        Mark as Investigate
      </button>
      <button
        title="Identical alarms will be shown in the future, this instance is considered closed."
        className="btn btn-success me-2"
        onClick={() => handleBulkAction('CLSD')}
        disabled={selectedAlerts.length === 0 || loading}
      >
        Close as Positive
      </button>
      <button
        className="btn btn-danger me-2"
        title="Alarm will be closed and identical alarms will be discarded in the future."
        onClick={() => handleBulkAction('FA')}
        disabled={selectedAlerts.length === 0 || loading}
      >
        Close as False Alarm
      </button>
    </div>
  );
};

export default StateFilterButtons;
